import ReactDOM from "react-dom/client";
import { App } from "./App";
import ErrorBoundary from "./components/app-error-boundary";
import "./i18n";
import "./index.css";
import React from "react";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const ErrorWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [error, setError] = React.useState<Error | null>(null);

    React.useEffect(() => {
        const handleError = (event: ErrorEvent) => {
            event.preventDefault();
            setError(event.error);
        };

        window.addEventListener("error", handleError);
        return () => window.removeEventListener("error", handleError);
    }, []);

    if (error) {
        throw error;
    }

    return <>{children}</>;
};

root.render(
    <React.StrictMode>
        <ErrorBoundary>
            <ErrorWrapper>
                <App />
            </ErrorWrapper>
        </ErrorBoundary>
    </React.StrictMode>
);
